<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :span="22" :offset="1" class="position-fixed">
        <el-col class="page-title" v-if="assessmentType===StakeholderType">Stakeholder Questionnaire Result Detail</el-col>
        <el-col class="page-title" v-if="assessmentType===VendorType && this.versionNo === undefined">Vendor Assessment Result Detail</el-col>
        <el-col class="page-title" v-if="assessmentType===VendorType && this.versionNo !== undefined">Vendor Assessment Result Detail History</el-col>
        <el-col :span="2" class="userInfo-title">Year: <span>{{userInfo.year}}</span></el-col>
        <el-col :span="3" class="userInfo-title">Status: <span>{{userInfo.status}}</span></el-col>
        <el-col :span="5" class="userInfo-title" v-if="assessmentType===StakeholderType">Category: <span>{{userInfo.category}}</span></el-col>
        <el-col :span="5" class="userInfo-title" v-if="assessmentType===StakeholderType">Organization: <span>{{userInfo.organization}}</span></el-col>
        <el-col :span="4" class="userInfo-title" v-if="assessmentType===StakeholderType">Staff: <span>{{userInfo.userName}}</span></el-col>
        <el-col :span="3" class="userInfo-title" v-if="assessmentType===VendorType">Vendor Name: <span>{{userInfo.userName}}</span></el-col>
        <el-col :span="2" class="userInfo-title" v-if="assessmentType===VendorType && isAdminRole">Score: <span>{{userInfo.score}}</span></el-col>
        <el-col :span="2" class="userInfo-title" v-if="assessmentType===VendorType">Grade: <span>{{userInfo.grade}}</span></el-col>
        <el-col :span="4" class="upload-content">
          <el-button type="danger" @click="exportPdf">Export</el-button>
        </el-col>
        <div class="line-detail"></div>
        </el-col>
      <el-col :span="22" :offset="1">
        <el-col :xl="3" :lg="4" :md="5" :sm="6">
          <div class="assessment-steps">
            <el-steps direction="vertical" :active="sectionList.length">
              <el-step :title="item.section" v-for="(item,index) in sectionList" :key="item.id" v-on:click.native="handleSection(index)" :status="item.status"></el-step>
            </el-steps>
            <!-- select language -->
            <el-select class="language-selector" v-model="value" @change="changeLanguage">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :xl="3" :lg="4" :md="5" :sm="6">&nbsp;</el-col>
        <el-col :xl="1" :lg="1" :md="1" :sm="1">
          <div class="line-vertical"></div>
        </el-col>
        <el-col :xl="21" :lg="20" :md="19" :sm="18">
          <div class="assessment-body" v-for="(section,index) in sectionList" :key="section.id" v-show="handleLastSection(index)">
            <div v-html="descriptionContent" v-if="assessmentType===StakeholderType&&currentSection===0" style="width: 70%"></div>
            <div class="description-body" v-html="descriptionChoiceTable" v-if="assessmentType===StakeholderType"></div><!--style="position: fixed"fixed-->
            <br/>
          <div class="assessment-body-title">{{section.section}}&nbsp;&nbsp;
            <el-tag v-if="showTag">{{sectionWarning}}</el-tag></div>
          <div class="assessment-body-question" v-for="(question, index) in section.questionVoList" :key="question.id">
            <!--<div class="assessment-body-subject"><span>{{index+1}}.&nbsp;</span><>{{question.question}}</div>-->
            <span>{{index+1}}.&nbsp;</span><span class="assessment-body-subject" v-html="question.question"></span>
            <!--single select-->
            <div v-if="question.multiSelect === 0">
              <el-radio-group v-model="selectOption.singleSelect[question.id]">
                <div class="assessment-body-answer" v-for="option in question.optionVoList" :key="option.id">
                  <el-radio :label="option.id" :disabled="optionStatus">{{option.option}}</el-radio>
                </div>
              </el-radio-group>
            </div>
            <!--multi select-->
            <div v-else>
            <el-checkbox-group v-model="selectOption.multipleSelect[question.id]" :disabled="optionStatus">
              <div class="assessment-body-answer-multiple" v-for="option in question.optionVoList" :key="option.id">
                <el-checkbox :label="option.id">{{option.option}}</el-checkbox>
              </div>
            </el-checkbox-group><br/>
            </div>
              <div class="assessment-body-answer" v-if="assessmentType===VendorType">
                <span>Alert:&nbsp;</span>
                <span v-if="alerted[question.id]===alertTrue">Yes</span >
                <span v-else-if="alerted[question.id]===alertFalse">No</span>
              </div><br/>
              <div class="assessment-body-answer" v-if="assessmentType===VendorType" >
                <span>Score:&nbsp;</span><span>{{optionScore[question.id]}}</span>
              </div>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
          </div>
          <!-- new section -->
          <div class="assessment-body" style="top: 180px" v-if="assessmentType===StakeholderType && section.type===newSectionType">
            <div class="assessment-body-title" style="margin-top: 10px;">{{section.section}}&nbsp;&nbsp;
            <el-tag v-if="showTagForLimitMultiSection(section)">{{sectionWarning}}</el-tag></div>
            <div class="peer-wording" v-html="section.descTop"></div>
            <div class="assessment-body-question">
              <div class="assessment-body-question" v-for="question in section.questionVoList" :key="question.id">
                <div class="assessment-body-subject" v-html="question.question"></div>
                <el-checkbox-group v-model="selectOption.multipleSelect[question.id]" :disabled="optionStatus">
                  <div class="assessment-body-answer-multiple" style="display: block;" v-for="option in question.optionVoList" :key="option.id">
                    <el-checkbox :label="option.id">
                      <div v-html="option.option"></div>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <div class="peer-tips" v-html="section.descBottom"></div>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
          </div>
          <!--Peer Evaluation Section 1 sectionList[currentSection].type===sectionType &&-->
          <div class="assessment-body" v-if="assessmentType===StakeholderType &&  section.selectCount === 1">
            <div class="assessment-body-title">{{section.section}}&nbsp;&nbsp;
              <el-tag v-if="showTag">{{sectionWarning}}</el-tag></div>
            <div style="margin-bottom: 20px" v-html="section.descTop"></div>
            <div class="assessment-body-question">
              <el-table :data="sectionList[currentSection].questionVoList" empty-text="No Data" style="text-align: center;width: 100%;z-index:8;" height="670px" border>
                <el-table-column v-for="(item, index) in section.questionVoList" :fixed="true" v-if="index===0" :key="item.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.question"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(item, index) in sectionList[currentSection].questionVoList[0].optionVoList" :label="item.option" :key="index">
                  <template slot-scope="scope" style="text-align: center">
              <span>
                <el-radio v-model="selectOption.singleSelect[scope.row.id]" :label="scope.row.optionVoList[index].id" :disabled="optionStatus">&nbsp;</el-radio></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
          </div>
          <!--Peer Evaluation Section 2   -->
          <div class="assessment-body" v-if="assessmentType===StakeholderType && section.type===sectionType && section.selectCount > 1">
            <div class="assessment-body-title">{{section.section}}&nbsp;&nbsp;
              <el-tag v-if="showTagForPeerSection()">{{sectionWarning}}</el-tag>
            </div>
            <div style="margin-bottom: 20px;" v-html="section.descTop"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionVoList" empty-text="No Data" style="text-align: center;width: 100%;z-index:8;" height="670px" border>
                <el-table-column v-for="(item, index) in sectionList[currentSection].questionVoList" :fixed="true" v-if="index===0" :key="item.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.question"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(item, index) in section.questionVoList[0].optionVoList" :label="item.option" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                <span>
                  <el-checkbox-group v-model="selectOption.peerSelect[index]" :disabled="optionStatus">
                    <el-checkbox :label="scope.row.id+','+scope.row.optionVoList[index].id">&nbsp;</el-checkbox>
                  </el-checkbox-group>
                </span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px;line-height: 20px;" v-html="section.descBottom"></div>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
          </div>
        </el-col>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import { questionnaireInfo, findUserInfo } from '@/services/answerer/questionnaire.service';
import { assessmentInfo, callFindUserInfo } from '@/services/answerer/assessment.service';
import { findAnswerDetailInfo, findAnswerDetailHistoryInfo } from '@/services/answerer/answerer.service'
import Footer from '../components/Footer.vue';
import Header from '../components/Header.vue';
import Constant from '../common/Constant'
import axios from 'axios';
import { verifyUserInfo } from '@/services/login.service'
import { findDicValue } from '@/services/dictionary.service'

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      options: [{
        value: Constant.LANGUAGE_EN,
        label: 'English'
      }, {
        value: Constant.LANGUAGE_SC,
        label: '中文简体'
      }, {
        value: Constant.LANGUAGE_TC,
        label: '中文繁體'
      }],
      languageList: [],
      assessment: {},
      optionStatus: true,
      VendorType: Constant.TYPE_VENDOR,
      StakeholderType: Constant.TYPE_STAKEHOLDER,
      selectEn: '',
      selectSc: '',
      selectTc: '',
      language: Constant.LANGUAGE_EN,
      value: Constant.LANGUAGE_EN,
      assessmentType: '',
      questionLength: '',
      sectionList: [],
      currentSection: 0,
      assessmentId: '',
      selectedInfo: {},
      selectOption: {
        singleSelect: {},
        multipleSelect: {},
        peerSelect: []
      },
      optionScore: '',
      alerted: '',
      userInfo: {},
      htmlTitle: 'AssessmentResultDetail',
      alertTrue: '1',
      alertFalse: '0',
      showTag: false,
      sectionWarning: Constant.MESSAGE_SECTION_WARNING_TEXT,
      multipleSelectedLength: 0,
      descriptionContent: '',
      descriptionChoiceTable: '',
      choiceLanguage: {},
      sectionType: Constant.SECTION_TYPE_PEER_EVALUATION,
      section: {},
      newSectionType: Constant.SECTION_TYPE_LIMITMULTISELECTION,
      isAdminRole: false,
      scoreObjects: [],
      roleType: ''
    }
  },
  methods: {
    async findAssessment (language) {
      this.$loading({fullscreen: true});
      this.language = language;
      let AssessmentInfo;
      if (this.assessmentType === Constant.TYPE_VENDOR) {
        AssessmentInfo = await assessmentInfo(this.assessmentId, this.language);
      } else {
        AssessmentInfo = await questionnaireInfo(this.assessmentId, this.language);
      }
      this.assessment = AssessmentInfo.data;
      switch (language) {
        case Constant.LANGUAGE_EN:
          this.sectionList = this.assessment.sectionEnList;
          this.choiceLanguage = this.$store.state.dictionary[1];
          break;
        case Constant.LANGUAGE_SC:
          this.sectionList = this.assessment.sectionScList;
          this.choiceLanguage = this.$store.state.dictionary[2];
          break;
        case Constant.LANGUAGE_TC:
          this.sectionList = this.assessment.sectionTcList;
          this.choiceLanguage = this.$store.state.dictionary[3];
          break;
      }
      this.initDescription();
      this.section = this.sectionList[this.currentSection];
      this.questionLength = this.sectionList[this.currentSection].questionVoList.length;
      this.handleStepStatus();
      this.$loading({fullscreen: true}).close();
    },
    async findAnswerDetailInfo () {
      let detailInfo;
      if (this.versionNo !== undefined) {
        detailInfo = await findAnswerDetailHistoryInfo(this.answerAssessmentId, this.versionNo, this.assessmentType);
      } else {
        detailInfo = await findAnswerDetailInfo(this.answerAssessmentId, this.assessmentType);
      }
      let answeredSectionIdSet = new Set();
      let alertInfo = {};
      let optionInfo = {};
      if (detailInfo.data.length > 0) {
        // Restore selected options
        this.selectedInfo = detailInfo.data;
        let radioInfo = {
          singleSelect: {},
          multipleSelect: {},
          peerSelect: []
        };
        this.selectedInfo.forEach(item => {
          answeredSectionIdSet.add(item.sectionId);
          if (item.multiSelect === '0') {
            radioInfo.singleSelect[item.questionId] = item.optionId;
            optionInfo[item.questionId] = item.optionScore;
            alertInfo[item.questionId] = item.alert;
            // optionInfo.singleScore[item.questionId] = item.optionScore;
          } else if (item.multiSelect === '1') {
            if (!radioInfo.multipleSelect[item.questionId]) {
              this.$set(radioInfo.multipleSelect, '' + item.questionId, []);
              this.multipleSelectedLength += 1;
            }
            radioInfo.multipleSelect[item.questionId].push(item.optionId);
            // statistic the score and alert
            if (optionInfo[item.questionId] !== undefined) {
              optionInfo[item.questionId] = (parseFloat(optionInfo[item.questionId]) + parseFloat(item.optionScore)).toString();
            } else {
              optionInfo[item.questionId] = item.optionScore;
            }
            if (alertInfo[item.questionId] !== undefined) {
              if (item.alert === '1' && alertInfo[item.questionId] !== '1') {
                alertInfo[item.questionId] = '1';
              } else if (item.alert === '0' && alertInfo[item.questionId] !== '0') {
                alertInfo[item.questionId] = '1';
              } else {
                alertInfo[item.questionId] = item.alert;
              }
            } else {
              alertInfo[item.questionId] = item.alert;
            }
          } else {
            if (!radioInfo.peerSelect[item.optionSequence - 1]) {
              this.$set(radioInfo.peerSelect, '' + item.optionSequence - 1, []);
            }
            radioInfo.peerSelect[item.optionSequence - 1].push(item.questionId + ',' + item.optionId);
          }
        });
        this.selectOption = radioInfo;
      }
      // add multiple selection array when not exists
      this.sectionList.forEach(section => {
        section.questionVoList.forEach(question => {
          if (!this.selectOption.multipleSelect[question.id] && question.multiSelect === 1) {
            this.$set(this.selectOption.multipleSelect, '' + question.id, []);
          }
        });
        if (section.type === Constant.SECTION_TYPE_PEER_EVALUATION && section.selectCount > 1) {
          for (let i = 0; i < section.questionVoList[0].optionVoList.length; i++) {
            if (!this.selectOption.peerSelect['' + i]) {
              this.$set(this.selectOption.peerSelect, '' + i, []);
            }
          }
        }
      });
      this.optionScore = optionInfo;
      this.alerted = alertInfo;
    },
    initDescription () {
      this.descriptionContent = this.choiceLanguage.DESCRIPTION_CONTENT;
      this.descriptionChoiceTable = this.choiceLanguage.DESCRIPTION_CHOICE_TABLE;
    },
    changeLanguage (val) {
      this.findAssessment(val);
    },
    nextSection () {
      if (this.currentSection < this.sectionList.length - 1) {
        this.currentSection++;
        this.questionLength += this.sectionList[this.currentSection].questionVoList.length;
      } else {
        this.currentSection = this.sectionList.length - 1;
      }
      this.section = this.sectionList[this.currentSection];
      this.isShowTag();
      this.handleStepStatus();
      document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
    },
    preSection () {
      if (this.currentSection > 0) {
        this.questionLength -= this.sectionList[this.currentSection].questionVoList.length;
        this.currentSection--;
      } else {
        this.currentSection = 0;
      }
      this.section = this.sectionList[this.currentSection];
      this.isShowTag();
      this.handleStepStatus();
      document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
    },
    handleSection (index) {
      if (index > this.currentSection) {
        let current = index - this.currentSection;
        for (let i = 0; i < current; i++) {
          this.currentSection++;
          this.questionLength += this.sectionList[this.currentSection].questionVoList.length;
        }
      } else if (index < this.currentSection) {
        for (let j = 0; j < this.currentSection - index; j++) {
          this.questionLength -= this.sectionList[this.currentSection].questionVoList.length;
        }
      } else {
        this.currentSection = index;
      }
      this.isShowTag();
      this.currentSection = index;
      this.section = this.sectionList[this.currentSection];
      this.handleStepStatus();
    },
    // find user info
    async initUserInfo () {
      let AnswererInfoDto = {
        answerAssessmentId: this.answerAssessmentId,
        userType: this.assessmentType,
        name: this.name,
        versionNo: this.versionNo
      };
      let userInfo;
      if (this.assessmentType === Constant.TYPE_VENDOR) {
        userInfo = await callFindUserInfo(AnswererInfoDto);
      } else {
        userInfo = await findUserInfo(AnswererInfoDto);
      }
      this.userInfo = userInfo.data;
    },
    handleStepStatus () {
      this.sectionList.forEach(item => {
        item.status = 'active';
      });
      this.sectionList[this.currentSection].status = 'process';
    },
    exportPdf () {
      this.$loading({fullscreen: true});
      let url;
      if (this.versionNo === undefined) {
        url = '/esg/security/auth/exportPdf?userType=' + this.assessmentType + '&grade=' + this.userInfo.grade +
          '&answerAssessmentId=' + this.answerAssessmentId + '&language=' + this.language;
      } else {
        url = '/esg/security/auth/exportPdf?userType=' + this.assessmentType + '&grade=' + this.userInfo.grade +
          '&answerAssessmentId=' + this.answerAssessmentId + '&language=' + this.language + '&versionNo=' + this.versionNo;
      }
      axios.get(url, {
        responseType: `blob`
      }).then(response => {
        if (response.status === 200 && response.data.size !== 0) { // request success
          let blob = new Blob([response.data], { // use Blob to handle response
            type: Constant.EXPORT_TYPE_PDF
          });
          let objectUrl = URL.createObjectURL(blob); // create a url object
          let link = document.createElement('a'); // create an a tag: <a></a>
          link.href = objectUrl; // set href
          let fileName = Constant.EXPORT_PDF_FILE_NAME_VENDOR; // download file's name
          if (this.versionNo !== undefined) {
            fileName = Constant.EXPORT_PDF_FILE_NAME_VENDOR_HISTORY; // download file's name
          }
          if (this.assessmentType === this.StakeholderType) {
            fileName = Constant.EXPORT_PDF_FILE_NAME_STAKEHOLDER;
          }
          link.setAttribute(Constant.EXPORT_LINK_ATTRIBUTE, fileName); // set link attribute
          document.body.appendChild(link); // put the link on the end of the body
          link.click();
          this.$loading({fullscreen: true}).close();
        } else {
          this.$alert(Constant.MESSAGE_EXPORT_PDF_FAILED, 'Warning', {
            confirmButtonText: 'OK'
          });
          this.$loading({fullscreen: true}).close();
        }
      });
    },
    isShowTag () {
      this.showTag = Object.getOwnPropertyNames(this.selectOption.singleSelect).length - 1 + this.multipleSelectedLength < this.questionLength;
    },
    showTagForPeerSection () {
      let handleStatusFlag = 0;
      this.selectOption.peerSelect.forEach(item => {
        if (item.length === this.section.selectCount) {
          handleStatusFlag += 1;
        }
      });
      return !(handleStatusFlag === this.selectOption.peerSelect.length);
    },
    showTagForLimitMultiSection (section) {
      let handleStatusFlag = 0;
      section.questionVoList.forEach(question => {
        if (this.selectOption.multipleSelect[question.id].length === section.selectCount) {
          handleStatusFlag += 1;
        }
      });
      return !(handleStatusFlag === section.questionVoList.length);
    },
    handleLastSection (index) {
      if (this.assessmentType === Constant.TYPE_STAKEHOLDER) {
        return this.currentSection === index && this.sectionList[index].type !== Constant.SECTION_TYPE_PEER_EVALUATION && this.sectionList[index].type !== Constant.SECTION_TYPE_LIMITMULTISELECTION;
      } else if (this.currentSection === index) {
        return true;
      } else {
        return false;
      }
    },
    async verifyUser () {
      let user = await verifyUserInfo();
      this.roleType = user.role;
      if (this.roleType === Constant.USER_TYPE_ADMIN || this.roleType === Constant.USER_TYPE_VENDOR) {
        this.isAdminRole = true;
      }
    },
    async loadScores () {
      let scores = await findDicValue(Constant.CONFIG_BUSINESS, Constant.ASSESSMENT_ANSWER_GRADE_SCOPE);
      let score = scores.data[0].dictValue.split('|');
      let scoreObj = [{}];
      for (let i = 0; i < score.length; i++) {
        scoreObj.push(score[i]);
      }
      let arr = [];
      for (let i = 1; i < scoreObj.length; i++) {
        let temp = scoreObj[i].split(':');
        let tempValue = temp[1].split('_');
        if (tempValue.length === 2 && i !== scoreObj.length) {
          let tempObj = {
            'down': tempValue[0],
            'up': tempValue[1],
            'key': temp[0]
          }
          arr[i - 1] = tempObj;
        }
      }
      this.scoreObjects = arr;
    }
  },
  created () {
    this.verifyUser();
  },
  mounted () {
    this.answerAssessmentId = this.$route.query.answerAssessmentId;
    this.assessmentType = this.$route.query.userType;
    this.assessmentId = this.$route.query.assessmentId;
    this.name = this.$route.query.name;
    this.versionNo = this.$route.query.versionNo;
    this.loadScores();
    this.findAssessment(this.language).then(value => {
      this.$loading({fullscreen: true});
      this.initUserInfo();
      this.findAnswerDetailInfo().then(value1 => {
        this.isShowTag();
        this.$loading({fullscreen: true}).close()
      })
    });
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
}

</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }

  .margin-left {
    margin-left: 15px;
  }

  .position-fixed {
    height: 170px;
    position: fixed;
    margin-top: 50px;
    background-color: #fff;
    z-index: 9;
    padding-top: 20px;
  }

  .page-title {
    font-size: 20px;
    line-height: 24px;
  }

  .userInfo-title {
    font-weight: bold;
    margin-top: 50px;
    font-size: 16px;
  }

  >>>@media screen and (max-width: 1620px) {
    .userInfo-title {
      font-size: 15px;
    }
  }

  .upload-content {
    padding-top: 30px;
  }

  .line-vertical {
    width: 1px;
    height: 720px;
    background-color: #e6e6e6;
    top: 200px;
    position: fixed;
    margin-left: 40px;
  }

  .line-detail {
    width: 91.66667%;
    height: 1px;
    background-color: #e6e6e6;
    position: fixed;
    top: 200px;
  }

  .assessment-body {
    padding: 35px 40px 90px 65px;
    position: relative;
    top: 185px;
  }

  .assessment-steps {
    margin-top: 230px;
    height: 450px;
    position: fixed;
  }

  >>>@media screen and (max-width: 800px) {
    .assessment-steps {
      display: none;
    }

    .line-vertical {
      display: none;
    }

    .assessment-body {
      padding: 35px 40px 90px 0;
      position: absolute;
      left:-20px;
      top: 180px;
    }
  }

  .language-selector {
    position: fixed;
    bottom: 50px;
  }

  .assessment-body-title {
    color: #2d2d2d;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .assessment-body-question{
    margin-right: 25px;
    margin-bottom: 25px;
  }

  .assessment-body-subject{
    color: #000;
    margin-bottom: 15px;
    line-height: 20px;
  }

  .assessment-body-answer{
    line-height: 30px;
    min-width: 100px;
    display: inline-block;
  }

  .assessment-body-answer-multiple{
    line-height: 30px;
    min-width: 260px;
    display: inline-block;
  }

  .assessment-body .el-button {
    width: 120px;
    height: 40px;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
  }

  .alert-class {
    margin-top: 20px;
    margin-bottom: 4px;
  }

  .answer-class {
    margin-bottom: 4px;
  }

  /* rewrite element ui */
  /*@media screen and (max-width: 1280px) {*/
    /*>>>.el-upload-list {*/
      /*left: 195px;*/
    /*}*/

    /*>>>.assessment-body {*/
      /*padding-left: 50px;*/
    /*}*/

    /*>>>.assessment-body-answer {*/
      /*margin: 20px 5px 0 15px;*/
      /*width: 240px;*/
    /*}*/
  /*}*/

  >>>.el-button {
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover {
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus {
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger {
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover {
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus {
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-step__icon {
    background-color: #c0c4cc;
  }

  >>>.el-step__head.is-wait {
    color: #ffffff;
  }

  >>>.el-step__head.is-finish {
    color: #ffffff;
    border-color: #5e89ed;
    cursor: pointer;
  }

  >>>.el-step__title.is-finish {
    color: #5e89ed;
    cursor: pointer;
  }

  >>>.el-step__title.is-finish:hover {
    color: #ffa600;
    font-weight: normal;
  }

  >>>.el-step__head.is-finish .el-step__line {
    background-color: #c0c4cc;
  }

  >>>.el-step__head.is-process {
    color: #ffffff;
    border-color: #5e89ed;
  }

  >>>.el-step__head.is-finish .el-step__icon {
    background-color: #5e89ed;
  }

  >>>.el-step__head.is-process .el-step__icon {
    background-color: #5e89ed;
  }

  >>>.el-step__title.is-process {
    color: #5e89ed;
  }

  >>>.el-step__description.is-process {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid;
    border-color: #5e89ed;
    background-color: #fff;
    padding-right: 0;
    margin-top: -5px;
    position: relative;
    right: 39px;
  }

  >>>.el-step__title.is-wait {
    color: #5e89ed;
    cursor: pointer;
  }

  >>>.el-step__title.is-wait:hover {
    color: #ffa600;
  }

  >>>.el-step__icon {
    background-color: #5e89ed;
  }

  >>>.el-step__head.is-wait {
    border-color: #5e89ed;
  }

  >>>.el-step__line {
    background-color: #ececec;
  }

  >>>.el-step__head.is-finish .el-step__line {
    background-color: #ececec;
  }

  >>>.el-radio {
    margin-left: 15px;
  }

  >>>.el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip {
    display: none;
  }

  >>>.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
  >>>.el-button--danger.is-disabled, .el-button--danger.is-disabled:active, .el-button--danger.is-disabled:focus, .el-button--danger.is-disabled:hover {
    color: #fff;
    background-color: #9ecdfde6;
    border-color: #9ecdfde6;
  }

  >>>.el-step__head.is-active{
    color: #ffffff;
    border-color: #5e89ed;
  }

  >>>.el-step__head.is-active .el-step__icon{
    background-color: #5e89ed;
  }

  >>>.el-step__title.is-active{
    color: #5e89ed;
  }

  >>>.el-step__description.is-active{
    width: 30px;
    border-radius: 50%;
    background-color: #fff;
    padding-right: 0;
    margin-top: -37px;
    position: relative;
    right: 39px;
  }

  >>>.el-step__title.is-active:hover{
    font-weight: bold;
  }

  >>>.el-step.is-vertical .el-step__title {
    max-width: 210px;
    line-height: 20px!important;
    float: left;
  }

  >>>@media screen and (max-width: 1450px) {
    .el-step.is-vertical .el-step__title {
      max-width: 160px;
    }
  }

  >>>@media screen and (max-width: 1280px) {
    .el-step.is-vertical .el-step__title {
      max-width: 120px;
    }

    .assessment-steps {
      height: 520px;
    }
  }

  >>>@media screen and (max-width: 1200px) {
    .line-vertical {
      margin-left: -20px;
    }
  }

  >>>.el-input{
    width: 120px;
    margin-top: 40px;
  }

  >>>.el-select-dropdown {
    width: 120px;
  }

  >>>.el-checkbox__input {
    vertical-align: top;
  }

  >>>.el-checkbox__label {
    vertical-align: top;
    margin-top: -3px;
    margin-bottom: 5px;
  }

 .description-body {
    height: 45px;
    position: -webkit-sticky;
    position: sticky;
    background-color: #fff;
    z-index: 9;
    box-shadow: 0 0 18px 3px rgba(26, 102, 255, 0.1);
    top: 210px;
    padding: 15px 0;
    font-size: 14px;
  }

  >>>a{
    color: #033dc6;
  }

</style>



// WEBPACK FOOTER //
// src/pages/QuestionnaireResultDetail.vue